import React, { Component } from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";
import Spinner from "../../atoms/Spinner";
import Numberformat from "../../atoms/Numberformat";

import EnterMulticurrencyInvestmentValue from "../../molecules/EnterMulticurrencyInvestmentValue";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    width: "100%"
    //maxWidth: "400px"
  },
  error: {
    color: "red"
  },
  actionsContainer: {
    marginTop: theme.spacing(3)
  },
  menu: {
    width: 200
  },
  spinner: {
    height: "19px"
  }
});

const min_token = 100;

class InvestmentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: null
    };

    // This binding is necessary to make `this` work in the callback
    this.handleClickNext = this.handleClickNext.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
  }
  handleClickNext(e, form) {
    e.preventDefault();
    this.setState({ direction: "next" });
    form.submitForm();
  }
  handleClickBack(e, form) {
    e.preventDefault();
    this.setState({ direction: "back" });
    form.submitForm();
  }
  renderAllErrorMsgs(errors) {
    const listErrors = errors => {
      let elist = [];
      Object.keys(errors).forEach((key, index) => {
        elist.push(
          <Typography key={index} style={{ color: "red" }} gutterBottom>
            {errors[key]}
          </Typography>
        );
      });
      return elist;
    };

    return (
      <Grid container spacing={10}>
        <Grid item>{listErrors(errors)}</Grid>
      </Grid>
    );
  }

  render() {
    const { investment } = this.props.data;
    const fetch_conversion = this.props.data.fetch_conversion;
    const { classes } = this.props;
    //console.log(fetch_conversion);
    return (
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            investment: investment,
            fetch_conversion: fetch_conversion.data
          }}
          onSubmit={(values, actions) => {
            this.props.save({
              section: "investment",
              data: {
                ...values.investment,
                Status: "created"
              }
            });

            if (this.state.direction === "next") {
              this.props.next();
            } else if (this.state.direction === "back") {
              this.props.back();
            }
            actions.setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            investment: Yup.mixed().test(
              "min",
              "You need to buy a minimum of " + min_token + " token.",
              value => value.token >= min_token
            )
          })}
          render={props => (
            <form
              onSubmit={props.handleSubmit}
              className={classes.container}
              name="WalletAddressForm"
            >
              <Typography>Select payment method and calculate price</Typography>
              {fetch_conversion.fetching && (
                <React.Fragment>
                  <Typography>Loading current conversion rate...</Typography>{" "}
                  <Spinner />
                </React.Fragment>
              )}
              {fetch_conversion.fetching_error !== null && (
                <React.Fragment>
                  <Typography
                    className={classes.error}
                    gutterBottom
                    align="center"
                  >
                    <br />
                    Failed to load conversion rate!
                    <br />
                    <Button
                      color="primary"
                      onClick={this.props.reload}
                      variant="outlined"
                      className={classes.button}
                    >
                      Reload
                    </Button>
                  </Typography>{" "}
                </React.Fragment>
              )}
              {fetch_conversion.fetching_success && (
                <EnterMulticurrencyInvestmentValue
                  name="investment"
                  min_token={min_token}
                  setFieldValue={props.setFieldValue}
                  error={typeof props.errors.investment !== "undefined"}
                  value={props.values.investment}
                  conversion={fetch_conversion.data}
                />
              )}
              {this.renderAllErrorMsgs(props.errors)}
              <div className={classes.actionsContainer}>
                {fetch_conversion.fetching_success && !this.props.saving && (
                  <Button
                    //type="submit"
                    name="next"
                    color="primary"
                    onClick={e => {
                      this.handleClickNext(e, props);
                    }}
                    variant="outlined"
                    className={classes.button}
                  >
                    BUY FOR &nbsp;
                    <Numberformat
                      value={props.values.investment.display.sum}
                      digits={
                        props.values.investment.currency === "EUR" ? 2 : 6
                      }
                    />
                    &nbsp;{props.values.investment.currency}
                  </Button>
                )}
                {this.props.data.saving && (
                  <Spinner className={classes.spinner} />
                )}
                {this.props.data.saving_error && (
                  <Typography className={classes.error}>
                    Saving Order failed! Please retry.
                  </Typography>
                )}
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}

InvestmentForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(InvestmentForm);
